import { render, staticRenderFns } from "./BillingAddressPage.vue?vue&type=template&id=7e700709&scoped=true&"
import script from "./BillingAddressPage.vue?vue&type=script&lang=ts&"
export * from "./BillingAddressPage.vue?vue&type=script&lang=ts&"
import style0 from "./BillingAddressPage.vue?vue&type=style&index=0&id=7e700709&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e700709",
  null
  
)

export default component.exports